import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon59: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M10 0c2.499 0 4.5 2.027 4.5 4.576 0 .138-.009.28-.026.423l2.22.001c.96 0 1.783.71 2.007 1.7l1.287 5.69a.5.5 0 0 1-.488.61l-1.5-.001v5.5c0 .82-.625 1.501-1.42 1.501H3.42C2.626 20 2 19.319 2 18.499v-5.5L.5 13a.5.5 0 0 1-.487-.61L1.299 6.7C1.523 5.71 2.346 5 3.307 5h2.22a3.49 3.49 0 0 1-.027-.424C5.5 2.027 7.502 0 10 0Zm1 12.999H3v5.5c0 .286.198.501.42.501H11v-6.001Zm6 0h-5V19h4.58c.223 0 .42-.215.42-.501v-5.5ZM16.694 6h-2.46a6.92 6.92 0 0 1-.13.345c-.273.672-.672 1.378-1.164 2.099a18.617 18.617 0 0 1-1.52 1.93 1.92 1.92 0 0 1-2.839 0 18.64 18.64 0 0 1-1.52-1.93c-.492-.721-.892-1.427-1.164-2.1A6.909 6.909 0 0 1 5.767 6L5.518 6H3.306c-.477 0-.907.371-1.031.921L1.125 12h17.75l-1.15-5.079c-.124-.55-.554-.921-1.03-.921ZM10 1C8.057 1 6.5 2.577 6.5 4.576c0 .4.11.87.323 1.393.243.598.608 1.244 1.064 1.91a17.68 17.68 0 0 0 1.426 1.813.92.92 0 0 0 1.374 0 17.618 17.618 0 0 0 1.427-1.813c.455-.666.82-1.312 1.063-1.91.213-.524.323-.994.323-1.393C13.5 2.576 11.944 1 10 1Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      />
    </Svg>
  )
}
